import React, { useEffect, useState } from 'react';
import { FiX } from 'react-icons/fi';
import DashboardDataTable from './DashboardDataTable';
import { fmtNumber } from './derive';

export default function RecordsSheet({ open, onClose, config }) {
  const [mounted, setMounted] = useState(open);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      const id = requestAnimationFrame(() => setVisible(true));
      return () => cancelAnimationFrame(id);
    }
    setVisible(false);
    const timeout = setTimeout(() => setMounted(false), 220);
    return () => clearTimeout(timeout);
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!mounted) return null;

  return (
    <div className="fixed inset-0 z-40">
      <div
        className={`absolute inset-0 bg-zinc-900/30 backdrop-blur-[1px] transition-opacity duration-200 motion-reduce:transition-none ${
          visible ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={onClose}
        aria-hidden
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-label={config?.title || 'Records'}
        className={`absolute inset-x-0 bottom-0 mx-auto flex h-[60vh] max-w-[1600px] flex-col overflow-hidden rounded-t-2xl border border-zinc-200 bg-white shadow-2xl transition-transform duration-200 ease-out motion-reduce:transition-none ${
          visible ? 'translate-y-0' : 'translate-y-full'
        }`}
      >
        <div className="flex items-center justify-between border-b border-zinc-100 px-4 py-2.5">
          <div className="flex items-center gap-2">
            <span className="h-1 w-10 rounded-full bg-zinc-200" aria-hidden />
            <h3 className="text-sm font-semibold text-zinc-900">{config?.title || 'Records'}</h3>
            {config ? (
              <span className="rounded-md bg-zinc-100 px-1.5 py-0.5 text-[10px] font-semibold tabular-nums text-zinc-600">
                {fmtNumber(config.totalRows || 0)}
              </span>
            ) : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close records"
            className="inline-flex h-7 w-7 items-center justify-center rounded-md text-zinc-500 transition-colors duration-150 hover:bg-zinc-100 hover:text-zinc-900 motion-reduce:transition-none"
          >
            <FiX className="h-4 w-4" />
          </button>
        </div>
        <div className="flex-1 overflow-hidden p-3">
          {config ? (
            <DashboardDataTable
              rows={config.rows}
              columns={config.columns}
              onRowClick={config.onRowClick}
              searchPlaceholder={config.searchPlaceholder}
              initialSort={config.initialSort}
              totalRows={config.totalRows}
              page={config.page}
              onPageChange={config.onPageChange}
              sort={config.sort}
              onSortChange={config.onSortChange}
              query={config.query}
              onQueryChange={config.onQueryChange}
              manualMode={config.manualMode}
            />
          ) : (
            <div className="flex h-full items-center justify-center text-sm text-zinc-500">
              No records available for this view.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
